/*
* This is the interface for the TmsInventory class. It is used to define the structure of the TMS_INVENTORY collection in Firestore.
*/

import { Timestamp, GeoPoint } from 'firebase/firestore';
import { FirestoreDocument } from './FirestoreDocument';
import { IClient, IOriginHub, ITransitLane } from './TmsAsset';
export interface Attachment {
  // TBD: Define properties for attachment objects
  filename: string;
  type: string; // image, pdf, etc.
  url: string;
  bolId?: string; // BOL document ID reference (for BOL attachments)
}

export interface TripHistoryItem {
  Location: string;
  LocationId: string;
  LocationGeocode: GeoPoint;
  Status: string;
  TimeStamp: Timestamp;
}

interface ITmsInventory {
  AddToCage: string;
  AssetId: string;
  Attachments: Attachment[] | null;
  Barcode: string;
  Bin: number;
  LatestBolId: string;
  Bols: { [key: string]: boolean };
  BolNumber: string;
  Category: string;
  Client: IClient;
  Comment: string;
  ConditionGrade: string;
  CostAtAcquisition: number;
  CreatedAt: Timestamp | null;
  CurrentValue: number;
  DistributionZone: string;
  ExpectedArrivalDate: Timestamp | null;
  ExpirationDate: Timestamp | null;
  Id: string | null;
  InboundShipmentId: string;
  Invoice: string;
  IsQuarantined: boolean;
  LastMovedDate: Timestamp | null;
  LotNumber: number;
  Manufacturer: string;
  Model: string;
  Notes: string;
  OriginHub: IOriginHub;
  TransitLane: ITransitLane;
  OutboundShipmentId: string;
  PackedDate: Timestamp | null;
  PickedDate: Timestamp | null;
  PickupByLinehaul: string;
  PurchaseOrderNumber: string;
  QuarantineReason: string;
  ReceivedDate: Timestamp | null;
  ReservedDate: Timestamp | null;
  ReturnDistributionZone: string;
  ReturnReason: string;
  Section: string;
  SerialNumber: string | null;
  ServiceTime: number;
  Shelf: string;
  ShippedDate: Timestamp | null;
  Shyftcode: string;
  Sku: string;
  Status: string;
  StoreNumber: string;
  Subcategory: string | null;
  Supplier: string;
  TmsOrderId: string;
  TripHistory: { [key: string]: TripHistoryItem[] } | TripHistoryItem[] | null;
  UpdatedAt: Timestamp | null;
  Warranty: string | number;
  ScannedAt: Timestamp | null;
  PrintQuantity: string;
  
  // Not managed by Asset system
  Volume: number | null;
  Weight: number | null;
  Name: string | null;
  Description: string | null;
  Upc: string | null;
  Price: string | null;
  Cost: string | null;  
  Quantity: number | null;
  QtyType: string | null; // Quantity type: 'pieces', 'skid pieces', 'liters', 'gallons', 'linear foot', etc.
}

export class TmsInventory extends FirestoreDocument implements ITmsInventory {
  AddToCage = '';
  AssetId = '';
  Attachments: Attachment[] = [];
  Barcode = '';
  Bin = 0;
  LatestBolId = '';
  Bols: { [key: string]: boolean } = {};
  BolNumber = '';
  Category = '';
  Client = { BusinessSubUnit: '', BusinessUnit: '' };
  Comment = '';
  ConditionGrade = '';
  CostAtAcquisition = 0;
  CreatedAt = Timestamp.now();
  CurrentValue = 0;
  DistributionZone = '';
  ExpectedArrivalDate = null as Timestamp | null;
  ExpirationDate = null as Timestamp | null;
  Id;
  InboundShipmentId = '';
  Invoice = '';
  IsQuarantined = false;
  LastMovedDate = null as Timestamp | null;
  LotNumber = 0;
  Manufacturer = '';
  Model = '';
  Notes = '';
  OriginHub = { Name: '', Id: '' };
  TransitLane = { Name: '', Id: '' };
  OutboundShipmentId = '';
  PackedDate = null as Timestamp | null;
  PickedDate = null as Timestamp | null;
  PickupByLinehaul = '';
  PurchaseOrderNumber = '';
  QuarantineReason = '';
  ReceivedDate = null as Timestamp | null;
  ReservedDate = null as Timestamp | null;
  ReturnDistributionZone = '';
  ReturnReason = '';
  Section = '';
  SerialNumber;
  ServiceTime = 0;
  Shelf = '';
  ShippedDate = null as Timestamp | null;
  Shyftcode = '';
  Sku = '';
  Status = '';
  StoreNumber = '';
  Subcategory = '';
  Supplier = '';
  TmsOrderId = '';
  TripHistory: { [key: string]: TripHistoryItem[] } | TripHistoryItem[] = {};
  UpdatedAt = null as Timestamp | null;
  Warranty = '';
  ScannedAt = Timestamp.now();
  PrintQuantity = '';
  Volume;
  Weight;
  Name;
  Description;
  Upc;
  Price;
  Cost;  
  Quantity;
  QtyType: string | null = null; // Quantity type: 'pieces', 'skid pieces', 'liters', 'gallons', 'linear foot', etc.
  Width;
  Length;
  Height;
  constructor(data?: Partial<ITmsInventory>) {
    super();
    if (data) {
      Object.keys(data).forEach(key => {
        if (key in this) {
          (this as any)[key] = (data as any)[key];
        }
      });
    }
  }

  protected get collectionName(): string {
    return 'TMS_INVENTORY';
  }    
}

